import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { PfFlightOptionComponent } from '../pf-flight-option/pf-flight-option.component';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { ArrivalTime, DepartureTime, Flightinfo } from '../models/flightModel';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: 'pf-flight-picker',
  imports: [
    ReactiveFormsModule,
    PfFlightOptionComponent,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    ScrollingModule,
    TranslocoModule
],
  templateUrl: './pf-flight-picker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pf-flight-picker.component.scss'
})

export class PfFlightPickerComponent implements OnInit {
  searchFlight = new FormControl('');
  @Input() flights: Flightinfo[] = [];
  @Input({ required: true }) type!: string;
  flightList: Flightinfo[] = [];
  filteredFlights: Flightinfo[] = [];
  searchFieldFocused: boolean = false;
  itemSize: number = 50;

  selectedIndex: number | null = null;

  selectedFlight: Flightinfo | null = null;

  getFlightTimeByType(flight: Flightinfo): DepartureTime | ArrivalTime {
    if (this.type === 'departure') {
      return flight.departureTime
    } else {
      return flight.arrivalTime
    }
  }

  ngOnInit(): void {
    if (this.type == 'departure') {
      this.flights.sort((a, b) => (a.departureTime.scheduled < b.departureTime.scheduled ? -1 : 1));
    } else {
      this.flights.sort((a, b) => (a.arrivalTime.scheduled < b.arrivalTime.scheduled ? -1 : 1));
    }

    this.flightList = this.flights;

    this.flights.map((flight) => {
      return flight.codeShareData.push(flight.flightId)
    })

    this.searchFlight.valueChanges.subscribe(value => {
      if (value != '') {
        let searchValue = value?.toLowerCase();
        this.filteredFlights = this.flights.filter((flight) => {
          let flightTime: any = flight[this.type + "Time" as keyof Flightinfo]

          let airport: any = this.type == 'departure' ? flight.arrivalAirportSwedish : flight.departureAirportSwedish;

          if (
            flight.flightId.includes(searchValue!) ||
            flightTime.scheduled.includes(searchValue!) ||
            airport.toLowerCase().includes(searchValue!)
          ) {
            return true;
          }

          if (flight.codeShareData.length > 0) {
            return flight.codeShareData.some(code => code.toLowerCase().includes(searchValue!));
          }
          return false;


        });

        this.flightList = this.filteredFlights;

      } else {
        this.flightList = this.flights;

      }

    });
  }

  onSelect(index: number): void {
    this.selectedIndex = index;
  }

  @Output() flightSelectedEvent = new EventEmitter();
  setSelectedFlight(flight: any): void {
    this.selectedFlight = flight;
    this.flightSelectedEvent.emit(flight);
  }

}
